<template>
    <div>
        <div class="bg-white p-5 pb-1 mb-3 rounded">
            <div
                class="d-lg-flex align-items-center justify-content-between mb-4 gap-2"
            >
                <div class="justify-content-star d-flex">
                    <h3>
                        <strong style="color: #1a0054"
                            >Lista de rutas inscritas</strong
                        >
                    </h3>
                </div>
                <div
                    class="justify-content-center d-lg-flex d-md-flex d-sm-grid"
                >
                    <search-input-component
                        :search="search"
                        @onSearch="onFilterSearch($event)"
                    ></search-input-component>

                    <a
                        :href="url_download_report"
                        class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2"
                        >Descarga reporte</a
                    >
                    <a
                        href="#crear_nueva_ruta"
                        class="btn bg-utel text-white rounded-8 mx-1 my-sm-2 pt-2"
                        >Crear nueva ruta</a
                    >
                    <a
                        href="#rutas_default"
                        class="btn bg-utel text-white rounded-8 mx-1 my-sm-2 pt-2"
                        >Ver rutas</a
                    >
                </div>
            </div>
            <v-data-table
                :loading="loadingTable"
                :headers="headersTabs"
                :items="routes"
                item-key="name"
                :search="search"
                class="elevation-1 table text-center align-middle small"
                loading-text="Cargando..."
                mobile-breakpoint="0"
                :header-props="{
                    sortIcon: 'fa-solid fa-sort-amount-desc',
                }"
                :footer-props="{
                    prevIcon: 'fa-solid fa-chevron-left',
                    nextIcon: 'fa-solid fa-chevron-right',
                    'items-per-page-text': 'Mostrando: ',
                    'items-per-page-options': [5, 10, 20, 30, 40, 50],
                }"
                hide-default-footer
            >
                <template v-slot:item="row">
                    <tr class="text-center">
                        <td>{{ row.item.id }}</td>
                        <td>{{ row.item.name }}</td>
                        <td>
                            {{
                                row.item.type_of === "custom"
                                    ? "Nueva"
                                    : "Predeterminada"
                            }}
                        </td>
                        <td
                            class="showXRoute"
                            data-bs-toggle="modal"
                            data-bs-target="#showInfoXRouteModal"
                            @click="showInfoXRoute(row.item, 'students')"
                        >
                            {{ row.item.students_count.count }}
                        </td>
                        <td
                            class="showXRoute"
                            data-bs-toggle="modal"
                            data-bs-target="#showInfoXRouteModal"
                            @click="showInfoXRoute(row.item, 'courses')"
                        >
                            {{ row.item.routes_count.count }}
                        </td>
                        <td
                            class="showXRoute"
                            data-bs-toggle="modal"
                            data-bs-target="#showInfoXRouteModal"
                            @click="showInfoXRoute(row.item, 'badges')"
                        >
                            {{ row.item.insignias_count.count }}
                        </td>
                        <td>
                            <button
                                type="button"
                                class="btn bg-utel-v2-secondary p-2 m-2 px-3 rounded-pill text-primary me-2"
                                alt="Editar"
                                title="Editar"
                                @click.prevent="openAddUsersModal(row.item)"
                            >
                                <i class="fa-regular fa-user"></i>
                            </button>
                        </td>
                        <td>
                            <button
                                type="button"
                                class="btn bg-utel-v2-secondary p-2 m-2 px-3 rounded-pill text-primary me-2"
                                alt="Remover usuarios"
                                title="Remover usuarios"
                                @click.prevent="openRemoveUsersModal(row.item)"
                            >
                                <i class="fa fa-user-times"></i>
                            </button>
                        </td>
                        <td>
                            <button
                                type="button"
                                class="btn bg-utel-v2-secondary p-2 m-2 px-3 rounded-pill text-primary me-2"
                                alt="Eliminar esta ruta"
                                title="Eliminar esta ruta"
                                @click.prevent="openDeleteModal(row.item)"
                            >
                                <i class="fa-regular fa-trash-can"></i>
                            </button>
                        </td>
                    </tr>
                </template>
                <template v-slot:footer>
                    <div class="text-center pt-2">
                        <v-pagination
                            v-model="page"
                            :length="pageCount"
                            :total-visible="6"
                            next-icon="fas fa-angle-right"
                            prev-icon="fas fa-angle-left"
                            @input="getData"
                        ></v-pagination>
                    </div>
                </template>
            </v-data-table>

            <modaldelete
                v-if="deleteModalVisible"
                :route="selectedRoute"
                :url="url_get"
                @reloadtable="onReloadTable"
                @close="closeDeleteModal"
            ></modaldelete>
            <modalmanagerouteusers
                v-if="manageUsersModalVisible"
                :route="selectedRoute"
                :mode="manageUsersMode"
                :urlstudents="url_get_students"
                @reloadtable="onReloadTable"
                @close="closeManageUsersModal"
            ></modalmanagerouteusers>
            <modalinforoute
                v-if="infoModalVisible"
                :route="infoXRoute"
                @close="closeShowInfoModal"
            ></modalinforoute>
        </div>
    </div>
</template>

<script>
import modaldelete from "./modals/ModalDeleteRoute.vue";
import modalmanagerouteusers from "./modals/ModalManageRouteUsers.vue";
import modalinforoute from "./modals/ModalShowInfo.vue";

export default {
    props: [
        "url_get",
        "url_add",
        "url_remove",
        "url_get_students",
        "url_download_report",
        "reload_table",
    ],
    components: {
        modaldelete,
        modalmanagerouteusers,
        modalinforoute,
    },
    data() {
        return {
            search: "",
            headersTabs: [
                { text: "No.", value: "id" },
                { text: "Nombre", value: "name" },
                { text: "Tipo", value: "ordpress_taxonomy_id" },
                { text: "Usuarios inscritos", value: "students_count.count" },
                { text: "Cursos", value: "routes_count.count" },
                { text: "Insignias", value: "insignias_count.count" },
                { text: "Agregar usuarios", value: "", align: "center" },
                { text: "Remover usuarios", value: "", align: "center" },
                { text: "Eliminar", value: "", align: "center" },
            ],
            routes: [],
            totalItems: 0,
            page: 1,
            itemsPerPage: 10,
            pageCount: 0,
            deleteModalVisible: false,
            manageUsersModalVisible: false,
            manageUsersMode: "add",
            infoModalVisible: false,
            infoXRoute: {},
            selectedRoute: {},
            loadingTable: true,
            searchTimeout: null
        };
    },
    mounted() {
        this.getData();
    },
    computed: {},
    watch: {
        reload_table(newVal) {
            if (newVal == true) {
                this.getData();
                this.$emit("setReload", false);
            }
        },
        search() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.page = 1;
                this.getData();
            }, 400);
        }
    },
    methods: {
        async getData() {
            try {
                this.loadingTable = true;
                let param = `?withUsers=true&page=${this.page}&per_page=${this.itemsPerPage}`;
                if (this.search) param += `&search=${this.search}`;

                const { data } = await axios.get(this.url_get + param);
                
                this.routes = data.data;
                this.totalItems = data.total;
                this.page = data.current_page;
                this.pageCount = data.last_page;
            } catch (error) {
                console.error("Error al cargar rutas:", error);
            } finally {
                this.loadingTable = false;
            }
        },
        onFilterSearch(searchText) {
            this.search = searchText;
        },
        openDeleteModal(route) {
            this.selectedRoute = route;
            this.deleteModalVisible = true;
        },
        openAddUsersModal(route) {
            this.selectedRoute = route;
            this.manageUsersMode = "add";
            this.manageUsersModalVisible = true;
        },
        openRemoveUsersModal(route) {
            this.selectedRoute = route;
            this.manageUsersMode = "remove";
            this.manageUsersModalVisible = true;
        },
        closeDeleteModal() {
            this.deleteModalVisible = false;
        },
        closeManageUsersModal() {
            this.manageUsersModalVisible = false;
        },
        onReloadTable() {
            this.getData();
        },
        showInfoXRoute(route, type) {
            const typeConfig = {
                students: { data: route.students_x_route, modalType: "lg" },
                courses: { data: route.courses_x_route, modalType: "md" },
                badges: { data: route.badges_x_route, modalType: "lg" },
            };

            this.infoXRoute = {
                id: route.id,
                name: route.name,
                type,
                modalType: typeConfig[type].modalType,
                [type]: typeConfig[type].data,
            };
            this.infoModalVisible = true;
        },
        closeShowInfoModal() {
            this.infoModalVisible = false;
        },
    },
};
</script>

<style></style>
